import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import Sitemark from './SitemarkIcon';
import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// For hide on scroll.
import Slide from '@mui/material/Slide';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import CssBaseline from '@mui/material/CssBaseline';


const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	flexShrink: 0,
	// For rounding:
	//borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
	// For square:
	borderRadius: 0,
	
	backdropFilter: 'blur(24px)',
	border: '1px solid',
	borderColor: (theme.vars || theme).palette.divider,
	backgroundColor: theme.vars
	  ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
	  : alpha(theme.palette.background.default, 0.4),
	boxShadow: (theme.vars || theme).shadows[1],
	padding: '8px 12px',
	width: '100%',
}));

// To hide AppBar on scroll.
function HideOnScroll(props) {
	const { children, window } = props;
	const trigger = useScrollTrigger()

	return (
		<Slide appear={false} direction='down' in={!trigger}>
			{children ?? <div />}
		</Slide>
	);
}

HideOnScroll.propTypes = {
	children: PropTypes.element,
};

export default function Header(props) {
  	const [open, setOpen] = React.useState(false);

  	const toggleDrawer = (newOpen) => () => {
  	  setOpen(newOpen);
  	};

       //         <MenuItem>Home</MenuItem>
       //         <MenuItem>About</MenuItem>
       //         <MenuItem>Blog</MenuItem>
       //         <MenuItem>Projects</MenuItem>
       //         <MenuItem>Resume</MenuItem>

	return (
<React.Fragment>
<CssBaseline />
<HideOnScroll {...props}>
<AppBar
	position="fixed"
	enableColorOnDark
	sx={{
		boxShadow: 0,
		bgcolor: 'transparent',
		backgroundImage: 'none',
		top: 0,
		mt: 0,
	}}
>
<StyledToolbar
	variant="dense" 
	disableGutters
	sx={{ width: '100%' }}
>

	<Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
	  <Sitemark />
	  <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
	    <Button variant="text" color="info" size="large" href='/'>
	      Home
	    </Button>
	    <Button variant="text" color="info" size="large" href='/projects'>
	      Projects
	    </Button>
	    <Button variant="text" color="info" size="large" href='/blog'>
	      Blog
	    </Button>
	    <Button variant="text" color="info" size="large" href='/cv'>
	      CV
	    </Button>
	    <Button variant="text" color="info" size="large" href='/about'>
	      About
	    </Button>
	    <Button variant="text" color="info" size="large" href='/contact'>
	      Contact
	    </Button>
	  </Box>
	</Box>

	<Box
	  sx={{
	    display: { xs: 'none', md: 'flex' },
	    gap: 1,
	    alignItems: 'center',
	  }}
	>
    	<IconButton
    	  color="inherit"
    	  size="medium"
    	  href="https://github.com/agge3"
    	  aria-label="GitHub"
    	  sx={{ alignSelf: 'center' }}
    	>
    	<FacebookIcon />
		</IconButton>

    	<IconButton
    	  color="inherit"
    	  size="medium"
    	  href="https://www.linkedin.com/in/baxtertyler"
    	  aria-label="LinkedIn"
    	  sx={{ alignSelf: 'center' }}
    	>
    	<LinkedInIcon />
		</IconButton>
		{/* The color drop-down is nice, but doesn't fit. Maybe another plan to
		incorporate? 
		<ColorModeIconDropdown size='medium'/>
		*/}
	</Box>

	<Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
	  <ColorModeIconDropdown size="medium" />
	  <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
	    <MenuIcon />
	  </IconButton>
	  <Drawer
	    anchor="top"
	    open={open}
	    onClose={toggleDrawer(false)}
	    PaperProps={{
	      sx: {
	        top: 'var(--template-frame-height, 0px)',
	      },
	    }}
	  >
	    <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
	      <Box
	        sx={{
	          display: 'flex',
	          justifyContent: 'flex-end',
	        }}
	      >
	        <IconButton onClick={toggleDrawer(false)}>
	          <CloseRoundedIcon />
	        </IconButton>
	      </Box>
		  {/*<MenuItem>Features</MenuItem>
	      <MenuItem>Testimonials</MenuItem>
	      <MenuItem>Highlights</MenuItem>
	      <MenuItem>Pricing</MenuItem>
	      <MenuItem>FAQ</MenuItem>
	      <MenuItem>Blog</MenuItem>
	      <Divider sx={{ my: 3 }} />
	      <MenuItem>
	        <Button color="primary" variant="contained" fullWidth>
	          Sign up
	        </Button>
	      </MenuItem>
	      <MenuItem>
	        <Button color="primary" variant="outlined" fullWidth>
	          Sign in
	        </Button>
	      </MenuItem>*/}
	    </Box>
	  </Drawer>
	</Box>

</StyledToolbar>
</AppBar>
</HideOnScroll>
</React.Fragment>
);
}
